import OnboardingLayout from '@jonni/core/ui/layout/layout.onboarding';
import React from 'react';

interface MainLayoutProps {
  children: React.ReactNode;
  pathName: string;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, pathName }) => {
  if (pathName.includes('signup')) {
    return <OnboardingLayout path={pathName}>{children}</OnboardingLayout>;
  }

  return <>{children}</>;
};

export default MainLayout;
